import { createAction } from "@reduxjs/toolkit";

const setCurrentBG = createAction("currentBG/set");

export { setCurrentBG };
